'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PopoverMenu = require('components/PopoverMenu/PopoverMenu');

var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);

var _PopoverMenuItem = require('components/PopoverMenu/PopoverMenuItem');

var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectItemPopover = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectItemPopover, _PureComponent);

  function ProjectItemPopover() {
    (0, _classCallCheck3.default)(this, ProjectItemPopover);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectItemPopover.__proto__ || (0, _getPrototypeOf2.default)(ProjectItemPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectItemPopover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onCreateSubproject = _props.onCreateSubproject,
          onDelete = _props.onDelete,
          onEdit = _props.onEdit,
          onReport = _props.onReport,
          onInit = _props.onInit;
      var _props2 = this.props,
          id = _props2.id,
          hideCreateSubproject = _props2.hideCreateSubproject,
          hideEdit = _props2.hideEdit,
          hideReport = _props2.hideReport,
          hideDelete = _props2.hideDelete;
      var t = this.context.t;


      return _react2.default.createElement(
        _PopoverMenu2.default,
        { id: id, ref: onInit },
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onCreateSubproject, title: t('Create project'), iconClass: 'icon-add', hidden: hideCreateSubproject }),
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onEdit, title: t('Edit'), iconClass: 'icon-mode-edit', hidden: hideEdit }),
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onReport, title: t('Report'), iconClass: 'icon-chart', hidden: hideReport }),
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete', hidden: hideDelete })
      );
    }
  }]);
  return ProjectItemPopover;
}(_react.PureComponent), _class.propTypes = {
  hideCreateSubproject: _propTypes2.default.bool,
  hideDelete: _propTypes2.default.bool,
  hideEdit: _propTypes2.default.bool,
  hideReport: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  onCreateSubproject: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onInit: _propTypes2.default.func,
  onReport: _propTypes2.default.func
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onCreateSubproject: _noop3.default,
  onDelete: _noop3.default,
  onEdit: _noop3.default,
  onInit: _noop3.default,
  onReport: _noop3.default
}, _temp);
exports.default = ProjectItemPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectItemPopover/ProjectItemPopover.js
// module id = 2064
// module chunks = 1